app.service('basketShare', function (simpleToastr) {
	// obecna wersja tylko jako POC, do dalszego rozwijania, Obecnie nie ma reprezentacyjnego linku koszyka
	async function run() {
		const title = 'Mój koszyk w Euro RTV AGD';
		const url = window.location.href;
		if (navigator.share) {
			await navigator.share({ title: title, url: url });
		} else {
			// fallback
			copyToClipboard(url);
		}
	}
	async function copyToClipboard(url) {
		await navigator.clipboard.writeText(url);
		simpleToastr.generate('Link do koszyka został skopiowany do schowka', 'success');
	}

	return {
		run
	};
});
